export default __webpack_public_path__ + "static/media/alert-outer.d57fb4a5.svg";